import {FC, memo, } from 'react'
import {CsvRow, DefaultInputStepErr, InputStepErr, InputStepMode, UploadPayload} from '..'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import Dropzone from 'react-dropzone'
import {read, utils} from 'xlsx'
import Papa from 'papaparse'

type InputStepUploadFileProps = {
  inputMode: InputStepMode
  finalData: UploadPayload
  error: InputStepErr
  setError: (error: InputStepErr) => void
  setCsvData: (data: CsvRow[]) => void
  setFinalData: (finalData: UploadPayload) => void
  setInputMode: (mode: InputStepMode) => void
}

const acceptedFileTypes = {
  'text/csv': ['.csv'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx', '.xls'],
}

const InputStepUploadFile: FC<InputStepUploadFileProps> = (props) => {
  const {error, finalData, inputMode, setInputMode, setFinalData, setCsvData, setError} = props

  const handleChange = (acceptedFiles: File[]) => {
    if (
      !Array.isArray(acceptedFiles) ||
      (Array.isArray(acceptedFiles) && acceptedFiles.length === 0)
    ) {
      return
    }

    const file = acceptedFiles[0]

    if (
      file.type !== 'text/csv' &&
      file.type !== 'application/vnd.ms-excel' &&
      file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return
    }

    file.arrayBuffer().then((res: any) => {
      let data = new Uint8Array(res)
      let workbook = read(data, {type: 'array'})
      let worksheet = workbook.Sheets[workbook.SheetNames[0]]
      let fdata = utils.sheet_to_csv(worksheet, {rawNumbers: true})
      Papa.parse<CsvRow>(fdata, {
        complete: function (results) {
          setFinalData({...finalData, name: file.name, file: file})
          setCsvData(results.data)
          setError(DefaultInputStepErr)
        },
      })
    })
  }

  return (
    <>
      <div className='fv-row mb-5'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input mb-6'
            type='radio'
            value=''
            id='flexRadioChecked6'
            checked={inputMode === InputStepMode.Upload}
            onChange={() => setInputMode(InputStepMode.Upload)}
          />
          <label
            className='form-check-label align-items-start flex-column d-flex ms-3'
            htmlFor='flexRadioChecked6'
          >
            <span className='card-label fw-bolder fs-5'>Import new list</span>
            <span className='text-muted fs-7'>
              Upload a new list from a file, Acceptable file Types: Comma Seprated CSV or text
              files.{' '}
              <a href='https://cellcast-profile-image.s3.ap-southeast-2.amazonaws.com/utils/sample_contacts.csv'>
                Download example CSV
              </a>
            </span>
            {inputMode === InputStepMode.Upload && (
              <>
                {finalData?.name !== '' ? (
                  <>
                    <section className='dragAndDrop'>
                      <div className='removeFile'>
                        <span className='fs-10'> {finalData?.name}</span>
                        <KTSVG
                          onClick={() => {
                            setCsvData([])
                            setFinalData({
                              name: '',
                              file: undefined,
                              mergeLabels: '',
                              tagIds: '',
                              unSubList: false,
                            })
                          }}
                          path='/media/misc/cross-square.svg'
                          className='svg-icon  reomveIcon'
                        />
                      </div>
                    </section>
                  </>
                ) : (
                  <Dropzone onDrop={handleChange} accept={acceptedFileTypes}>
                    {({getRootProps, getInputProps}) => (
                      <section className='dragAndDrop'>
                        <KTSVG path={'/media/svg/dragandDrop.svg'} className='svg-icon-3x me-3' />
                        <div {...getRootProps()}>
                          <input {...getInputProps()} />
                          <span className='fs-7 d-block fw-boldest'>
                            Drop files here or click to upload
                          </span>
                          <span className='text-muted fs-7'>csv,xlsx</span>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                )}
              </>
            )}
          </label>
        </div>
      </div>
      <span className='ps-12'>{finalData?.name}</span>
      {error.upload !== '' && <span className='text-danger mx-10 mb-10'>{error.upload}</span>}
    </>
  )
}

export default memo(InputStepUploadFile)
